import { render, staticRenderFns } from "./DiscountBadge.vue?vue&type=template&id=dfd98db4&scoped=true"
import script from "./DiscountBadge.vue?vue&type=script&lang=js"
export * from "./DiscountBadge.vue?vue&type=script&lang=js"
import style0 from "./DiscountBadge.vue?vue&type=style&index=0&id=dfd98db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd98db4",
  null
  
)

export default component.exports